<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed, ref } from "vue";

const props = defineProps<{
  src?: string;
  preview: boolean;
}>();

const showPreview = ref(false);

const previewList = computed(() => (props.src ? [{ src: props.src }] : []));
function onClickImage() {
  if (!props.preview) return;
  showPreview.value = true;
}
</script>
<template>
  <div class="previewable-image">
    <nut-image v-bind="$attrs" :src="src" @click="onClickImage" />
    <nut-image-preview
      :show="showPreview"
      :images="previewList"
      :autoplay="0"
      @close="showPreview = false"
    />
  </div>
</template>
